// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { Button, Overlay, Area, Picker, DatetimePicker, Popup, Toast, Collapse, CollapseItem } from 'vant'
import http from './service/http'
import BaiduMap from 'vue-baidu-map'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'

Vue.use(Collapse).use(CollapseItem)
Vue.use(Button)
Vue.use(Overlay)
Vue.use(Area)
Vue.use(Picker)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(Mint)

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'jz6n9hV5DGMLiGd5MG3xoYEAqYKdGSg9'
})

Vue.config.productionTip = false
// 绑定到原型方法
Vue.prototype.$http = http
// 不可删除提示
Vue.prototype.$openTips = function (content) {
  const h = this.$createElement
  this.$notify({
    title: '提示',
    message: h('i', { style: 'color: teal' }, content)
  })
}
// 获取url参数
Vue.prototype.$urlParam = function (key) {
  let query = window.location.search.substring(1),
    attr = {},
    match,
    pl = /\+/g,
    search = /([^&=]+)=?([^&]*)/g,
    decode = s => {
      return decodeURIComponent(s.replace(pl, ' '))
    }
  this._searchArgs = query
  while ((match = search.exec(query))) { attr[decode(match[1])] = decode(match[2]) }
  if (!key) return query
  return attr[key] || ''
}
Vue.prototype.$getSecondMenu = function (callback) {
  // debugger;
  let param = {
    url: this.$route.matched[1].path
  }
  this.$http.getMenu(param, ([code, body]) => {
    this.$httpResult(code, body, () => {
      // this.secondMemuList = body.data
      callback(body.data)
    })
  })
},
Vue.prototype.$getPermission = function (name, callback) {
  let param = {
    url: name
  }
  this.$http.getPermission(param, ([code, body]) => {
    this.$httpResult(code, body, () => {
      // this.secondMemuList = body.data
      callback(body)
    })
  })
},
// 接口数据验证
Vue.prototype.$httpResult = function (code, body, success) {
  if (code == 200) {
    // 根据后台返回数据的验证字段进行判断接口是否调通 body.code先随便写的
    if (body.code === 0) {
      success && success()
    } else {
      // 提示后台返回的错误原因
      Toast(body.msg)
    }
    // 接口错误
    //
  } else if (code == 401) {
    localStorage.clear()
    router.push({path: '/login'})
    Toast('当前账号在其他设备登录，请重新登录')
  } else if (code == -1) {
    // this.$openWarning('禁止重复提交');
  } else if (code == 404) {
    Toast('接口未找到')
  } else {
    Toast(body.msg)
  }
},
Vue.prototype.$delSpace = function (str, is_global) {
  var result
  result = str.replace(/(^\s+)|(\s+$)/g, '')
  if (is_global.toLowerCase() == 'g') {
    result = result.replace(/\s/g, '')
  }
  return result
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js